import dayjs from 'dayjs';

import { getNthWeekdayOfMonth } from './getNthWeekdayOfMonth.ts';
import { getWeekdayOccurrenceInMonth } from './getWeekdayOccurrenceInMonth.ts';

export const getMonthlyWeekdayRecurrenceDates = ({ startDate, amount }: { startDate: Date; amount: number }) => {
  const { dayOfWeek, occurrence } = getWeekdayOccurrenceInMonth(startDate);
  const start = dayjs(startDate);

  const results = [];
  for (let i = 0; i < amount; i++) {
    const currentYear = start.add(i, 'month').year();
    const currentMonth = start.add(i, 'month').month(); // 0-based
    const nthDate = getNthWeekdayOfMonth(currentYear, currentMonth, dayOfWeek, occurrence);
    if (nthDate) {
      results.push(nthDate);
    } else {
      // If the nth occurrence doesn't exist for some reason that month,
      // decide how you want to handle this case. Here we just skip it.
    }
  }

  return results;
};
